import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DigitalWalletService } from '../account/digital-wallet/services/digital-wallet.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardGuard  {
    public constructor(private router: Router,
                       private readonly dwService: DigitalWalletService,
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return true;
    }
}
